import {useAppDispatch, useAppSelector} from '../../../../../../../../../hooks/react-redux'
import {getDraft} from '../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {pipelineDraft} from '../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../hooks/pipeline'
import {useInlineInput} from '../../../../../../hooks/useInlineInput'
import {EditButton} from '../../../../EditButton/EditButton'
import SettingsBlock from '../../../../SettingsBlock/SettingsBlock'

import BranchSettings from './BranchSettings/BranchSettings'

import styles from './PipelineRepository.css'

import Input, {Size} from 'src/components/pages/PipelinesPages/components/common/Input'

export function PipelineRepository() {
  const id = usePipelineId()
  const url = useAppSelector(state => getDraft(state, id)?.vcsRoot.url ?? '')

  const [isEditingUrl, setIsEditingUrl, urlInputHandlers] = useInlineInput()
  const dispatch = useAppDispatch()

  return (
    <SettingsBlock
      id="repository"
      title="Repository"
      collapsible
      collapsedDefault
      collapsedNote={url}
    >
      <div className={styles.urlSectionWrapper}>
        {isEditingUrl ? (
          <Input
            autoFocus
            size={Size.FULL}
            className={styles.input}
            value={url}
            onChange={e => dispatch(pipelineDraft.actions.setUrl({id, url: e.currentTarget.value}))}
            {...urlInputHandlers}
          />
        ) : (
          <div
            role="presentation"
            className={styles.urlSection}
            onClick={() => setIsEditingUrl(true)}
          >
            {url}
            <EditButton iconClassName={styles.editUrlIcon} className={styles.editUrl} />
          </div>
        )}
      </div>
      <BranchSettings />
    </SettingsBlock>
  )
}
